<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'AddressDataView',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        text: 'CEP',
        value: 'postalCode',
        handle: vm.handleCep,
      },
      {
        text: 'Logradouro',
        value: 'street',
      },
      {
        text: 'Número',
        value: 'number',
      },
      {
        text: 'Bairro',
        value: 'neighborhood',
      },
      {
        text: 'Complemento',
        value: 'complement',
      },
      {
        text: 'Cidade',
        value: 'city',
      },
      {
        text: 'Estado',
        value: 'state',
        handle: vm.handleState,
      },
    ],
  }),
};
</script>
